export const BACKGROUND_OPTION_ID = 'block_background_image';
